import { render, staticRenderFns } from "./ExtendedCall.vue?vue&type=template&id=4c266cd2&scoped=true&"
import script from "./ExtendedCall.vue?vue&type=script&lang=js&"
export * from "./ExtendedCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c266cd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VProgressLinear,VSimpleTable})
